<template>
  <div :class="$style.wrapper">
    <div
      :class="[$style.image, $style.isSide]"
      :style="{ backgroundImage: `url('${sideImage || '/images/default-car-side.jpg'}')` }"
    />
    <div
      :class="[$style.image, $style.isFront]"
      :style="{ backgroundImage: `url('${frontImage || '/images/default-car-front.jpg'}')` }"
    />
    <div
      :class="[$style.image, $style.isBack]"
      :style="{ backgroundImage: `url('${backImage || '/images/default-car-back.jpg'}')` }"
    />
  </div>
</template>

<script>
export default {
  props: {
    frontImage: {
      type: String,
      default: null,
    },
    sideImage: {
      type: String,
      default: null,
    },
    backImage: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" module>
.wrapper {
  $chart-height: 380px;
  $row-gar: 5px;
  $right-column-width: ($chart-height - $row-gar) / 2;
  display: grid;
  grid-template-rows: $right-column-width $right-column-width;
  grid-template-columns: 1fr $right-column-width;
  row-gap: 5px;
  column-gap: 18px;
  overflow: hidden;
  border-radius: 5px;

  .image {
    position: relative;
    width: 100%;
    background-color: $disabled;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;

    &.isSide {
      grid-row-start: 1;
      grid-row-end: 3;
      grid-column-start: 1;
      grid-column-end: 2;
    }

    &.isFront {
      grid-row-start: 1;
      grid-row-end: 2;
      grid-column-start: 2;
      grid-column-end: 3;
      padding-top: 100%;
    }

    &.isBack {
      grid-row-start: 2;
      grid-row-end: 3;
      grid-column-start: 2;
      grid-column-end: 3;
      padding-top: 100%;
    }

    &::after {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: inline-block;
      content: '';
      background: linear-gradient(
        180deg, rgba(230, 230, 230, 0.5) 0%, rgba(146, 147, 148, 0.25) 70%, rgba(15, 18, 20, 0.25) 100%
      );
    }
  }
}
</style>
